import * as yup from 'yup';
import { SettlementModel } from '../../types/SettlementModel';
export const updateAgencyRiskTierPayload = yup.object({
    agencyId: yup.number().required(),
    riskTier: yup.string().oneOf(['TRUSTED', 'LOW', 'MEDIUM', 'MEDIUM_2', 'HIGH', 'HIGH_PLUS_4']).required(),
});
export const updateAgencyPayload = yup.object({
    agencyId: yup.number().required(),
    defaultSplitBasisPoints: yup.number().integer().optional().nullable(),
    defaultAchFlatFeeAmount: yup.number().integer().optional().nullable(),
    defaultEftFlatFeeAmount: yup.number().integer().optional().nullable(),
    lockboxEnabled: yup.boolean().optional(),
    eLockboxEnabled: yup.boolean().optional(),
    lockboxCheckProcessingFee: yup.number().integer().optional().nullable(),
    premiumFinanceEnabled: yup.boolean().optional(),
    debitsToEpicEnabled: yup.boolean().optional(),
    isMigrated: yup.boolean().optional(),
    settlementModel: yup.string().oneOf(Object.values(SettlementModel)).optional().nullable(),
});
//# sourceMappingURL=agency.js.map